function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm4.43 16.559l-1.768-.008L12 13.377l-2.66 3.171-1.771.008a.213.213 0 0 1-.214-.214.223.223 0 0 1 .051-.139l3.485-4.152L7.406 7.9a.223.223 0 0 1-.051-.139.215.215 0 0 1 .214-.214l1.771.008L12 10.73l2.66-3.171 1.768-.008a.213.213 0 0 1 .214.214.223.223 0 0 1-.051.139l-3.479 4.149 3.482 4.152a.223.223 0 0 1 .051.139.215.215 0 0 1-.215.215z" /></svg>;
});